export const c_nav_c_menu__item_m_current_after_BorderColor = {
  "name": "--pf-c-nav--c-menu__item--m-current--after--BorderColor",
  "value": "#73bcf7",
  "var": "var(--pf-c-nav--c-menu__item--m-current--after--BorderColor)"
};
export default c_nav_c_menu__item_m_current_after_BorderColor;